import React from 'react';
import {
    Button,
    Subheading,
    Popover,
    Stack,
    DisplayText
} from '@shopify/polaris';
import './StatItem.scss';

class StatItem extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            tooltipActive: false,
        }
    }

    render() {

        const activator = <Button onMouseEnter={() => this.setState({ tooltipActive: !this.state.tooltipActive })} onClick={() => this.setState({ tooltipActive: !this.state.tooltipActive })} plain monochrome removeUnderline={true}>
            <Subheading><span className="statsSubHeading">{this.props.title}</span></Subheading>
        </Button>;

        return (
            <Stack vertical={true}>
                <Stack.Item>
                    <Popover
                        preferredAlignment="left"
                        preferredPosition="above"
                        sectioned={false}
                        active={this.state.tooltipActive}
                        activator={activator}
                        onClose={() => this.setState({ tooltipActive: !this.state.tooltipActive })}
                    >
                        <Popover.Pane>
                            <Popover.Section>
                                {this.props.text}
                            </Popover.Section>
                        </Popover.Pane>
                    </Popover>
                </Stack.Item>
                <Stack.Item>
                    <DisplayText size="large">{this.props.stat}</DisplayText>
                </Stack.Item>
            </Stack>
        );
    }
}

StatItem.defaultProps = {
}

export default StatItem;